'use client';

import { c as _c } from "react/compiler-runtime";
import PropTypes from 'prop-types';
import { useHydrateAtoms } from 'jotai/utils';
import warehouseIdForUserAtom from './warehouseIdForUserAtom';

/**
 * Seeds warehouseIdForUserAtom with the warehouse the server resolved from the
 * visitor's zip cookie, so the server render and the first client render agree
 * (CON-8558). Without this the atom starts at DEFAULT_WAREHOUSE_ID on the
 * client no matter what the server rendered.
 *
 * There is one Jotai store per page load (JotaiProvider is mounted in
 * AllProviders from the root layout with no `store` prop, and never remounts on
 * client navigation), so this hydrates once. Deliberately hydrate-only, never
 * `dangerouslyForceHydrate`: on a soft navigation from another page the
 * client-resolved value must win over this late-mounting hydrator.
 *
 * Wraps its readers rather than sitting beside them - useHydrateAtoms only wins
 * over a reader that mounts after it, and as a sibling that ordering would rest
 * on nothing but the order the elements happen to appear in.
 */
const WarehouseIdHydrator = t0 => {
  const $ = _c(2);
  const {
    warehouseId,
    children
  } = t0;
  let t1;
  if ($[0] !== warehouseId) {
    t1 = [[warehouseIdForUserAtom, warehouseId]];
    $[0] = warehouseId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useHydrateAtoms(t1);
  return children;
};
WarehouseIdHydrator.propTypes = {
  warehouseId: PropTypes.string,
  children: PropTypes.node
};
export default WarehouseIdHydrator;